import Vue from "vue";
const vm = new Vue()
import swapLang from "./swapLang.js";
import { helpers } from 'vuelidate/lib/validators'
import courierRules from "@/constants/CourierRules";

export const TYPE_CART_DEFAULT = "DEFAULT"
export const TYPE_CART_COURIER = "COURIER"
export const TYPE_CART_PREBARCODE = "PREBARCODE"
export const TYPE_CART_GEN = "GEN"
export const TYPE_CART_COD = "COD"
export const TYPE_CART_DROPOFF_SHIPPOP = "DROPOFF_SHIPPOP"
export const TYPE_CART_DROPOFF_EASYSHIP = "DROPOFF_EASYSHIP"
export const TYPE_CART_DROPOFF_VRICH = "DROPOFF_VRICH"
export const TYPE_CART_DROPOFF_QUICK = "DROPOFF_QUICK"
export const TYPE_CART_DROPOFF_KERRY = "DROPOFF_KERRY" // [KERRY , ORANGE]
export const TYPE_CART_DROPOFF_LAZADA = "DROPOFF_LAZADA"
export const TYPE_CART_DROPOFF_LINE = "DROPOFF_LINE"
export const TYPE_CART_DROPOFF_INTER = "DROPOFF_INTER"
export const TYPE_CART_DROPOFF_LAO = "DROPOFF_LAO"
export const TYPE_CART_DROPOFF_FLASH = "DROPOFF_FLASH"
export const STEP_FULL_FILLUP = "FULL_FILLUP"
export const STEP_SELECT_COURIER_INTER = "SELECT_COURIER_INTER"
export const STEP_PAGE_FIRST = "FIRST"
export const STEP_PAGE_CHECKPRICE = "CHECKPRICE"
export const STEP_COURIER = "COURIER"
export const STEP_LINEBOOKING = "LINEBOOKING"
export const SUB_STEP_CREATEBOOKING = "CREATEBOOKING"
export const SUB_STEP_CHECKPRICE = "CHECKPRICE"

export const getTypeCart = {
  TYPE_CART_DEFAULT,
  TYPE_CART_COURIER,
  TYPE_CART_PREBARCODE,
  TYPE_CART_GEN,
  TYPE_CART_COD,
  TYPE_CART_DROPOFF_SHIPPOP,
  TYPE_CART_DROPOFF_EASYSHIP,
  TYPE_CART_DROPOFF_VRICH,
  TYPE_CART_DROPOFF_QUICK,
  TYPE_CART_DROPOFF_KERRY,
  TYPE_CART_DROPOFF_LAZADA,
  TYPE_CART_DROPOFF_LINE,
  TYPE_CART_DROPOFF_INTER,
  TYPE_CART_DROPOFF_LAO,
  TYPE_CART_DROPOFF_FLASH
}

export const getStepPage = {
  STEP_SELECT_COURIER_INTER,
  STEP_FULL_FILLUP,
  STEP_PAGE_FIRST,
  STEP_PAGE_CHECKPRICE,
  STEP_COURIER,
  STEP_LINEBOOKING,
  SUB_STEP_CREATEBOOKING,
  SUB_STEP_CHECKPRICE,
}

export const groupBy = (array, key) => {
  return Array.prototype.slice.call(array).reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    return result;
  }, {});
};
export const swapBarcode = barcode => {
    let swap = barcode.split('')
    let scanBarcode = '';
    swap.forEach(value =>{
      if(swapLang[value]){
        scanBarcode += swapLang[value]
      }else{
        scanBarcode += value
      }
    });
    return scanBarcode;
}

export const checkCodAmount = (value) => !helpers.req(value) || !( value < 100 || value > 50000 )


export const checkPersonID = personID => {
	if( personID.length != 13 ) return false;
	let sum = 0;

	for( let i = 0 ; i < 12; i++ ){
		sum += parseFloat( personID.charAt(i) ) * (13-i);
	}
	let chkbit = parseFloat( personID.charAt( 12 ) );

	let mod = sum % 11;
	let sub = 11 - mod;
	let check_digit = sub % 10;
	if ( check_digit != chkbit ) {
		return false;
	}
    
	return true;
}

export const validatePassportNo = passportNo => {
  const regex = /^[A-Z0-9]{6,20}$/i;
  return regex.test(passportNo);
}

export const typeParcel = type => {
    switch ( String(type) ) {
		case 'ship':
        return { name: 'พัสดุ' }
		case 'item':
        return { name: 'สินค้า' }
		case 'service':
        return { name: 'บริการ' }
        default:
        return { name: '' }
	}
}

export const printReceipt = (html , time = 100)=> {

	const win = window.open("");
	if( !win ){
		const errorMsg = 'ระบบพิมพ์อัตโนมัติไม่สามาถใช้งานได้ กรุณากดอนุญาต Pop-ups เพื่อพิมพ์ใบปะหน้า'
		alert(errorMsg)
		return errorMsg
	}
	win.document.write(html);
	setTimeout(() => {
		win.document.close();
		win.focus();
		win.print();
		win.close();
	}, time);
}

export const resetPage = () => {
	location.reload();
}

export const checkTax = (value) => !helpers.req(value) || checkPersonID(value)

export const checkWeightMaximumByCourierCode = ( value , courierCode ) => {
	let oldValue = typeof value !== 'number' ? parseFloat(value) : value;
    let newValue = (vm.$THEME.unitKG) ? (oldValue * 1000) : oldValue

    if( courierRules[courierCode] && newValue > courierRules[courierCode].maxWeight ){
        return (vm.$THEME.unitKG) ? (courierRules[courierCode].maxWeight/1000) : courierRules[courierCode].maxWeight
    }else{
        return oldValue
    }
}

export const checkWeightMaximumByCourierRate = ( value , courierRate ) => {
    if( !value ){
        return value;
    }

	let oldValue = typeof value !== 'number' ? parseFloat(value) : value;
    let maxRate = courierRate[courierRate.length-1].max

    if(oldValue > maxRate){
        return maxRate
    }else{
        return oldValue
    }
}

export const switchLockCourier = (type = TYPE_CART_DEFAULT, objectLock = {}) => {
  console.log('type: is', type)
  Object.keys(objectLock).forEach(key => {
    switch ( String(type) ) {
      case TYPE_CART_COURIER: 
        if( ![
              'courier',
              'cod',
              'gen',
              'dropoffEasyship'
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_PREBARCODE:
        if(![
              'prebarcode',
              'cod',
              'gen',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_KERRY:
        if(![
              'dropoffKerry',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_LAZADA:
        if(![
              'dropoffLazada',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_QUICK:
        if(![
              'dropoffQuick',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_VRICH:
        if(![
              'dropoffVrich',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_SHIPPOP:
        if(![
              'dropoffShippop',
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_LINE:
        objectLock[key] = true;
        break;
      case TYPE_CART_DROPOFF_LAO:
        if(![
              'dropoffINTER',
              'dropoffLAO'
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DROPOFF_INTER:
        if(![
              'dropoffINTER',
              'dropoffLAO'
            ].includes(key)
        ){
          objectLock[key] = true;
        }
        break;
      case TYPE_CART_DEFAULT:
        objectLock[key] = false;
        break;
      default:
        objectLock[key] = false;
        break;
    }
  })
}
